import request from '@/utils/request'
export function Blogtop(data) {//BLOG页面top文章
	return request({
		url:'/measure/hot',
		method: 'get'
	})
}
export function Blogs(data) {//BLOG页面分页文章
	return request({
		url:'/measure/Page',
		method: 'post',
		data:data
	})
}
export function Blogxq(data) {//BLOG页面分页文章
	return request({
		url:`/measure/${data}`,
		method: 'get'
	})
}
export function Blogfenlei(data) {// //BLOG页面分类
	return request({
		url:`/datadict/SOLUTION`,
		method: 'get'
	})
}

